// removed by extract-text-webpack-plugin
module.exports = {"buttons":"trash-document-modal__buttons___3ytTm"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/trash-document-modal.scss
// module id = 1334
// module chunks = 0